import all from './all';
import create from './create';
import deletes from './delete';
import patch from './patch';

export default {
  all,
  create,
  deletes,
  patch,
};
